import {useRef} from 'react';
import {useNavigate} from 'react-router-dom';

import {SimpleGrid} from '@mantine/core';

import {usePrices} from '../hooks/usePrices.ts';
import {usePricesSelection} from '../hooks/usePricesSelection.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
    DataTableTokenPagination,
} from '@flexinet/ui-components';

interface RecordsTableProps {
    productId?: string;
}

export const RecordsTable = ({productId}: RecordsTableProps) => {
    const {
        selectedRecords,
        setSelectedRecords
    } = usePricesSelection();
    const {columns} = useTableColumns();
    const navigate = useNavigate();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = usePrices(productId);

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                isRecordSelectable={(record) => record.priceStatus === 'Active'}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
                // FNP-323: row click navigates to the prices detail page; edits go
                // through the EditPage's top-bar Edit button instead of an in-row drawer.
                onRowClick={({record}) => navigate(`/prices/${record.id}`)}
            />

            <DataTableTokenPagination loadedCount={totalCount} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>
        </SimpleGrid>
    );
};
